export default __webpack_public_path__ + "static/media/Porco - Productivo.png_.e001377b.png";